<script>
	import { createEventDispatcher } from 'svelte'
	import { fly, fade } from 'svelte/transition'
	import LogHourItem from './LogHourItem.svelte'
	// import ThinButton from '../../../components/ThinButton/ThinButton.svelte'
	import ActionButton from '../../../components/ActionButton/ActionButton.svelte'
	import SmartField from '../../../components/SmartField/SmartField.svelte'
	import SmartSelect from '../../../components/SmartField/SmartSelect.svelte'
	import LogsMetaEditor from './LogMetaEditor.svelte'

	export let data

	let grandTotal = 0,
		editing = false,
		adding = false,
		editModel = {}

	const dispatch = createEventDispatcher()

	const onTimeLogUpdate = (event) => {
		const { detail } = event
		const { notes, type } = data
		dispatch('log-time-update', {
			...detail,
			...{
				notes,
				type
			}
		})

		adding = false
		data.editing = false
	}

	const onTimeLogCreate = (event) => {
		const { client, date, description, notes, program, type } = data
		const { user, time, resolver: resolverTimelog } = event.detail
		const resolver = () => {
			console.log('timelog create resolver')
			resolverTimelog()
			onEditCancel()
		}
		// console.log ('onTimeLogCreate', event.detail, data)
		dispatch('log-time-create', {
			client,
			date,
			description,
			notes,
			program,
			type,
			user,
			time,
			resolver
		})

		adding = false
		data.editing = false
	}

	const onEditStart = (event) => {
		editing = true
		editModel = { ...data }
	}

	const onEditEnd = (event) => {
		if (editing) onEditComplete()

		editing = false
		adding = false
	}

	const onAddingStart = (event) => {
		adding = true
	}

	const onEditCancel = () => {
		editing = false
		adding = false
		dispatch('cancel', data)
	}

	const onEditComplete = () => {
		// console.log ('onEditComplete', editModel);
		const { id, program, description, notes, type } = editModel
		dispatch('update', {
			id,
			program,
			description,
			notes,
			type
		})
	}

	const onAddLog = (event) => {
		data.siblings.push({
			time: 0,
			user: { name: 'Scegli Operatore' },
			id: Math.random(),
			editing: true,
			blank: true
		})
		data.siblings = data.siblings
	}

	const onTimeLogCreationCanceled = (log) => {
		data.siblings.splice(data.siblings.indexOf(log), 1)
		data.siblings = data.siblings
	}

	const calculateGrandTotal = () => {
		grandTotal = 0
		grandTotal += data.time ? data.time : 0
		if (data.siblings) {
			data.siblings.forEach((it) => {
				grandTotal += it.time
			})
		}
		grandTotal = grandTotal
	}

	function onDeleteHour() {
		adding = false
		editing = false
		data.editing = false
	}

	function onDataUpdate(d) {
		if (data.editing) {
			adding = true
		}
	}

	$: onDataUpdate(data)
	$: calculateGrandTotal(data)
</script>

{#if editing || adding}
	<div class="editing-overlay" in:fade={{ duration: 200 }}></div>
{/if}

<div class="LogItem clearfix type-{data.type}" class:editing class:adding>
	<div class="relative-holder">
		<div class="icon bg-color-{data.sector.color}">
			<i class="fad {data.sector.icon}"></i>
		</div>
		<div class="data">
			<div class="meta">
				<div class="lbl">{data.description}</div>
				<div class="txt">
					Settore:
					{#if data.sector}
						{data.sector.name}
					{:else}
						---
					{/if}
				</div>
				<div class="txt company-notes">Note: {data.notes}</div>
				{#if data.custom_notes && data.custom_notes !== ''}
					<div class="txt custom-notes">{data.custom_notes}</div>
				{/if}

				<div class="hover">
					<div class="ctrls">
						{#if editing || adding}
							<ActionButton icon="far fa-times" danger on:click={onEditCancel} />
							<ActionButton icon="far fa-check" success on:click={onEditEnd} />
						{:else}
							<ActionButton icon="far fa-plus" on:click={onAddingStart} />
							<ActionButton icon="far fa-pencil" on:click={onEditStart} />
						{/if}
					</div>
				</div>
			</div>

			{#if editing}
				<LogsMetaEditor bind:data={editModel} />
			{/if}

			{#if adding}
				<div class="add-log-item" in:fly={{ x: 40, duration: 150 }} on:click={onAddLog}>
					<i class="far fa-plus plus"></i>Aggiungi Log
				</div>
			{/if}

			{#if data.user && data.time}
				<LogHourItem
					log={data}
					name={data.user.name}
					time={data.time}
					id={data.id}
					on:update={onTimeLogUpdate}
					on:delete={onDeleteHour}
					on:delete
				/>
			{/if}

			{#if data.siblings}
				{#each data.siblings as log (log.id)}
					<LogHourItem
						{log}
						name={log.user.name}
						time={log.time}
						id={log.id}
						editing={log.editing}
						on:creation-canceled={onTimeLogCreationCanceled(log)}
						on:create={onTimeLogCreate}
						on:update={onTimeLogUpdate}
						on:delete={onDeleteHour}
						on:delete
					/>
				{/each}
			{/if}
			<LogHourItem time={grandTotal} name="Tempo totale" id={null} log={null} grandtotal />
		</div>
	</div>
</div>

<style>
	.LogItem {
		margin: 20px 20px;
	}

	.LogItem .relative-holder {
		position: relative;
		width: 100%;
	}

	.LogItem .icon {
		position: absolute;
		top: 0;
		left: 0;
		float: left;
		width: 46px;
		height: 46px;
		line-height: 40px;
		text-align: center;
		background-color: #5eb6f9;
		border-radius: 50%;
		margin: 3px 10px 0 0;
		color: #fff;
		transition: background-color 0.6s ease;
		border: 3px solid #d5e1e6;
	}

	.LogItem.type-0 .icon.bg-color-0 {
		background-color: #3fdad6;
	}
	.LogItem.type-1 .icon.bg-color-0 {
		background-color: #a29bfe;
	}
	.LogItem.type-0 .icon.bg-color-1 {
		background-color: #5eb6f9;
	}
	.LogItem.type-1 .icon.bg-color-1 {
		background-color: #ff9392;
	}

	.LogItem .data {
		/* float: left; */
		position: relative;
		top: 0;
		left: 56px;
		width: 350px;
	}

	@media (max-width: 640px) {
		.LogItem .data {
			width: calc(100% - 66px);
		}
	}

	.LogItem .data .meta {
		position: relative;
		padding: 7px 10px;
		background-color: #fff;
		border-radius: 3px;
	}
	.LogItem .data .meta .hover {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		/* text-align: center; */
		text-align: right;
		padding: 0 5px;
		display: none;
		z-index: 4;
		/* background-color: rgb(186 202 208 / 82%); */
		border-radius: 3px;
	}
	.LogItem .data .meta:hover .hover,
	.LogItem.editing .data .meta .hover {
		display: block;
	}
	.LogItem .data .meta .hover .ctrls {
		position: absolute;
		top: 50%;
		right: 0;
		width: 100%;
		transform: translateY(-50%);
		padding: 0 10px;
	}

	.LogItem .data .lbl {
		font-weight: 600;
	}
	.LogItem .data .txt {
		font-size: 13px;
		line-height: 15px;
	}

	.LogItem .data .company-notes {
		color: #4494d2;
	}

	.LogItem .data .custom-notes {
		color: #37c78e;
	}

	.editing-overlay {
		position: fixed;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgb(186, 202, 208, 0.8);
		z-index: 20;
	}
	.LogItem.adding {
		position: relative;
		z-index: 21;
	}
	.LogItem.editing .meta {
		position: relative;
		z-index: 21;
	}
	/* .LogItem .data .meta-editor {
        padding: 7px 10px;
        margin-top: 5px;
        background-color: #fff;
        border-radius: 3px;
        position: relative;
        z-index: 21;
    } */
	.add-log-item {
		background-color: #fdfbdd;
		border-radius: 2px;
		margin-top: 5px;
		position: relative;
		padding: 1px 0;
	}
	.add-log-item:hover {
		background-color: #859db3;
		color: #fff;
	}
	.add-log-item .plus {
		width: 40px;
		text-align: center;
	}
</style>
